import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { SubscriptionBalanceInfo } from '../../../../shared/types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SubscriptionBalanceSubscriptionVariables = Types.Exact<{
  scope: Types.AccountSubscriptionSubscriptionScopeInput;
}>;


export type SubscriptionBalanceSubscription = { __typename?: 'Subscription', accountSubscription?: { __typename?: 'UpdateAccountSubscriptionPayload', accountSubscription?: { __typename?: 'AccountSubscription', id: string, balance: number } | null } | null };


export const SubscriptionBalance = /*#__PURE__*/ gql`
    subscription SubscriptionBalance($scope: AccountSubscriptionSubscriptionScopeInput!) {
  accountSubscription(scope: $scope) {
    ... on UpdateAccountSubscriptionPayload {
      accountSubscription {
        ...SubscriptionBalanceInfo
      }
    }
  }
}
    ${SubscriptionBalanceInfo}` as unknown as DocumentNode<SubscriptionBalanceSubscription, SubscriptionBalanceSubscriptionVariables>;

          

          export const useSubscriptionBalanceSubscription = (options?:SubscriptionHookOptions<SubscriptionBalanceSubscription, SubscriptionBalanceSubscriptionVariables>) => useSubscription(SubscriptionBalance, options);

          

          export type SubscriptionBalanceSubscriptionOptions = SubscriptionHookOptions<SubscriptionBalanceSubscription, SubscriptionBalanceSubscriptionVariables>;

          

          export type SubscriptionBalanceSubscriptionResult = ReturnType<typeof useSubscriptionBalanceSubscription>;

          
